(function ($) {

'use strict';

	/**
	 * Copy the passed text to the clipboard
	 * @param {string} text the text to copy
	 * @param {bool} throwExceptionOnError if an error occurs the function output a message. 
	 *		If this parameter is true an excepttion will be thrown insted
	 * @returns {undefined}
	 */
	$.copyClipboard = function(text, throwExceptionOnError) {

		try {
			var el = document.createElement('textarea');  // Create a <textarea> element
			el.value = text;                                 // Set its value to the string that you want copied
			el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
			el.style.position = 'absolute';
			el.style.left = '-9999px';                      // Move outside the screen to make it invisible
			//document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
			$('body').prepend(el);
			if ($.isIE()) {
				$(document).scrollTop(0);
			}
			var selected =
					document.getSelection().rangeCount > 0        // Check if there is any content selected previously
					? document.getSelection().getRangeAt(0)     // Store selection if found
					: false;                                    // Mark as false to know no selection existed before
			el.select();                                    // Select the <textarea> content
			document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
			document.body.removeChild(el);                  // Remove the <textarea> element
			if (selected) {                                 // If a selection existed before copying
				document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
				document.getSelection().addRange(selected);   // Restore the original selection
			}
			$.showMessiInfo('Information', $.i81n.text('CLIPBOARD_DATA_AVAILABLE'), 3000, 'anim info');
		} catch (e) {
			if (!throwExceptionOnError) {
				console.error('{}!', e);
				$.showMessiDlgToConfirm($.i81n.text('ERROR_TITLE'), $.i81n.text('ERR_CLIPBOARD_COPY'), 'anim error');
			} else {
				throw e;
			}
		}
	};
}(jQuery));